import styled from 'styled-components';
import { Button } from '../../../../components/common/buttons/Button';
import { SecitionDivideLine } from '../../../../views/Product/detailView/ProductDetailView/components/SecitionDivideLine';
import { IMyOwnTractor } from '../../../../interfaces/OwnTractor.interfaces';
import { userOwnTractorSurveySlice, userOwnTractorSurveyStateType } from '../../../../store/userOwnTractorSurveySlice';
import { useAppDispatch } from '../../../../hooks/store/useStore';
import { MachineApprovalStatus } from '../../../../constants/machine/machine.constant';
import { useNavigate } from 'react-router-dom';
import { useTogglePokeStatus } from '../../../../hooks/user/useTogglePokeStatus';
import { IPokeActionType } from './MyInfoUserOwnProductCard';
import { ampli } from '../../../../ampli';
import { ownTractorPageInfo } from '../../../../constants/pageInfo/pageInfo.constant';

interface IMoreButtonsProps {
  selectedTractor: IMyOwnTractor;
  onPokeStatusUpdated: IPokeActionType;
  handleDeleteOwnTractor: () => void;
}

export const MoreButtons = ({ selectedTractor, onPokeStatusUpdated, handleDeleteOwnTractor }: IMoreButtonsProps) => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const userOwnTractorActions = userOwnTractorSurveySlice.actions;
  const { APPROVAL, PSWAITING } = MachineApprovalStatus;

  const { handleTogglePokeStatus } = useTogglePokeStatus({
    tractor: selectedTractor,
    onSuccess: onPokeStatusUpdated,
  });

  const handleEditOwnTractor = () => {
    if (!selectedTractor || !selectedTractor.id) {
      return;
    }

    ampli.pvmClickMyEditOwnTractor();

    const payload: Partial<userOwnTractorSurveyStateType> = {
      ownTractorIdForEdit: selectedTractor?.id,
      marketPrice: selectedTractor?.marketPrice ? Number(selectedTractor?.marketPrice) / 10000 : undefined,
    };

    if (selectedTractor.machine?.approvalStatus === APPROVAL || selectedTractor.machine?.approvalStatus === PSWAITING) {
      Object.assign(payload, {
        isApprovedTractor: true,
        manufacturedYear: selectedTractor?.manufacturedYear,
        operationTime: selectedTractor?.operationTime,
        brand: selectedTractor.brand.name,
        brandId: selectedTractor.brand.id,
        model: selectedTractor.machine.model,
        engineOutputInPs: selectedTractor.machine.engineOutputInPs,
      });
    }
    dispatch(userOwnTractorActions.changeOwnTractorSurveyForEdit(payload));
    navigate('/survey/progress/own-tractor/required-input-overview');
  };

  return (
    <Container>
      <ButtonSection>
        <Button
          borderType={'square'}
          color={'nakedGreyStrong'}
          size={'md'}
          text={{ content: '수정하기', size: 'md' }}
          onClick={handleEditOwnTractor}
        />
        <Button
          borderType={'square'}
          color={'nakedGreyStrong'}
          size={'md'}
          text={{ content: '사진 관리하기', size: 'md' }}
          onClick={() => {
            ampli.pvmEnterOwnTractorImageUploadPage({ from: 'my_own_tractor_page_extra_menu' });
            dispatch(userOwnTractorActions.changeIsOwnTractorSurveyStartedProperly(true));
            dispatch(userOwnTractorActions.changeOwnTractorIdForEdit({ ownTractorIdForEdit: selectedTractor.id }));
            navigate(ownTractorPageInfo.imageUploadPage.path);
          }}
        />
        <Button
          borderType={'square'}
          color={'nakedGreyStrong'}
          size={'md'}
          text={{ content: selectedTractor.isPokeEnabled ? '찔러보기 받지 않기' : '찔러보기 받기', size: 'md' }}
          onClick={() => {
            const newPokeStatus = !selectedTractor.isPokeEnabled;
            ampli.pvmClickMyTogglePokeStatus({
              status: newPokeStatus ? 'PUBLIC' : 'PRIVATE',
              position: 'more-modal',
            });
            handleTogglePokeStatus();
          }}
        />

        <Button
          borderType={'square'}
          color={'nakedSecondaryStrong'}
          size={'md'}
          text={{ content: '삭제', size: 'md' }}
          onClick={handleDeleteOwnTractor}
        />
      </ButtonSection>
      <SecitionDivideLine />
    </Container>
  );
};
const Container = styled.div`
  padding-bottom: 16px;
`;

const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  padding-bottom: 16px;
`;
